import React from 'react';

export default function TermsOfService() {
  const s = {
    page: { minHeight: '100vh', background: '#F5F8FC', paddingTop: 100, paddingBottom: 60 },
    wrap: { maxWidth: 800, margin: '0 auto', padding: '0 24px' },
    title: { fontSize: 32, fontWeight: 700, color: '#1B3A5C', marginBottom: 8 },
    updated: { fontSize: 14, color: '#6B7B8D', marginBottom: 32 },
    h2: { fontSize: 20, fontWeight: 600, color: '#1B3A5C', marginTop: 32, marginBottom: 12 },
    p: { fontSize: 15, lineHeight: 1.75, color: '#333', marginBottom: 12 },
    ul: { paddingLeft: 24, marginBottom: 12 },
    li: { fontSize: 15, lineHeight: 1.75, color: '#333', marginBottom: 4 },
    a: { color: '#4A9BD9', textDecoration: 'none' },
    footer: { marginTop: 48, paddingTop: 24, borderTop: '1px solid #D6E4F0', fontSize: 14, color: '#6B7B8D' }
  };

  return (
    <div style={s.page}>
      <div style={s.wrap}>
        <h1 style={s.title}>Terms of Service</h1>
        <p style={s.updated}>Effective Date: 1 January 2026</p>

        <h2 style={s.h2}>1. Acceptance of Terms</h2>
        <p style={s.p}>
          By accessing or using the Global Mind Wellness Centre platform
          (<a style={s.a} href="https://globalmindwellness.org">globalmindwellness.org</a>),
          you agree to be bound by these Terms of Service ("Terms"). If you do not agree,
          do not use the platform.
        </p>

        <h2 style={s.h2}>2. Description of Services</h2>
        <p style={s.p}>
          GMW provides a hybrid AI-human telemedicine platform for mental health services.
          Services include an AI-powered intake assistant that gathers preliminary information,
          online appointment booking, secure video consultations with licensed clinicians,
          clinical notes, prescriptions where clinically appropriate, and payment processing
          via PayPal and M-Pesa.
        </p>

        <h2 style={s.h2}>3. AI Intake Disclaimer</h2>
        <p style={s.p}>
          <strong>The AI intake assistant is NOT a medical device, diagnostic tool, or
          substitute for professional clinical assessment.</strong> It is designed solely to
          collect preliminary information before your appointment. The AI does not diagnose,
          treat, or prescribe. All clinical decisions are made exclusively by your assigned,
          licensed clinician. Do not rely on the AI for medical advice.
        </p>

        <h2 style={s.h2}>4. Registration and Accounts</h2>
        <ul style={s.ul}>
          <li style={s.li}>You must be at least 18 years old to create an account.</li>
          <li style={s.li}>You must provide accurate, current, and complete information during registration.</li>
          <li style={s.li}>You are responsible for maintaining the confidentiality of your account credentials.</li>
          <li style={s.li}>You must immediately notify us of any unauthorised use of your account.</li>
          <li style={s.li}>Clinician accounts are created only by GMW administrators — clinicians cannot self-register.</li>
        </ul>

        <h2 style={s.h2}>5. Clinician Services</h2>
        <p style={s.p}>
          All clinicians on the platform are registered with the relevant professional body
          (e.g., KMPDC for Kenya). Clinician profiles, qualifications, and specializations
          are published on the platform. However, GMW acts as a platform provider and does
          not guarantee specific clinical outcomes. The clinician-patient relationship is
          formed between you and the clinician, not with GMW.
        </p>

        <h2 style={s.h2}>6. Appointments and Cancellations</h2>
        <ul style={s.ul}>
          <li style={s.li}>Appointments are subject to clinician availability.</li>
          <li style={s.li}>You may cancel or reschedule up to 24 hours before the scheduled time at no charge.</li>
          <li style={s.li}>Cancellations within 24 hours may incur a cancellation fee as displayed at the time of booking.</li>
          <li style={s.li}>If a clinician cancels, you will be offered a full refund or rescheduling at your choice.</li>
          <li style={s.li}>GMW is not liable for failures caused by your internet connection, device, or browser.</li>
        </ul>

        <h2 style={s.h2}>7. Payments and Refunds</h2>
        <ul style={s.ul}>
          <li style={s.li}>Prices are displayed in Kenya Shillings (KES). PayPal payments are converted to USD at the rate shown at checkout.</li>
          <li style={s.li}>Payment is processed at the time of booking confirmation.</li>
          <li style={s.li}>Refund requests must be submitted within 7 days of the original payment and are assessed on a case-by-case basis.</li>
          <li style={s.li}>M-Pesa transaction disputes are subject to Safaricom's resolution process.</li>
          <li style={s.li}>GMW reserves the right to update pricing with 30 days' notice.</li>
        </ul>

        <h2 style={s.h2}>8. Crisis and Emergency Protocol</h2>
        <p style={s.p}>
          <strong>This platform is NOT a crisis service and is not monitored 24/7 for
          emergencies.</strong> If you or someone else is in immediate danger, contact your
          local emergency services right away (e.g., 999, 112, or your country's emergency
          number). Our AI system includes a crisis-language detector that, when triggered,
          sends an alert to GMW administrators during business hours. This is a safety
          supplement, not a substitute for emergency services.
        </p>

        <h2 style={s.h2}>9. User Conduct</h2>
        <p style={s.p}>You agree NOT to:</p>
        <ul style={s.ul}>
          <li style={s.li}>Use the platform for any purpose other than legitimate mental health services.</li>
          <li style={s.li}>Harass, threaten, or abuse clinicians, staff, or other users.</li>
          <li style={s.li}>Record, screenshot, or distribute session content without the other party's explicit consent.</li>
          <li style={s.li}>Attempt to gain unauthorised access to any part of the platform.</li>
          <li style={s.li}>Provide false information during intake or registration.</li>
          <li style={s.li}>Share your account credentials with any other person.</li>
        </ul>
        <p style={s.p}>
          Violation of these rules may result in immediate account termination without refund.
        </p>

        <h2 style={s.h2}>10. Intellectual Property</h2>
        <p style={s.p}>
          All content on the platform — including text, graphics, logos, icons, and software
          — is the property of GMW or its licensors and is protected by copyright, trademark,
          and other intellectual property laws. You may not reproduce, distribute, or create
          derivative works without our written permission.
        </p>

        <h2 style={s.h2}>11. Limitation of Liability</h2>
        <p style={s.p}>To the fullest extent permitted by law:</p>
        <ul style={s.ul}>
          <li style={s.li}>GMW is a platform provider and is not a party to the clinician-patient relationship.</li>
          <li style={s.li}>GMW shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising from your use of the platform.</li>
          <li style={s.li}>GMW does not guarantee uninterrupted or error-free operation of the platform.</li>
          <li style={s.li}>GMW's total liability for any claim shall not exceed the amount you paid to GMW in the 12 months preceding the claim.</li>
        </ul>
        <p style={s.p}>
          Nothing in these Terms excludes liability for death or personal injury caused by
          negligence, or any other liability that cannot be excluded under applicable law.
        </p>

        <h2 style={s.h2}>12. Indemnification</h2>
        <p style={s.p}>
          You agree to indemnify and hold harmless GMW, its directors, employees, and
          affiliated clinicians from any claims, damages, losses, or expenses (including
          legal fees) arising from your use of the platform or violation of these Terms.
        </p>

        <h2 style={s.h2}>13. Prescriptions</h2>
        <p style={s.p}>
          Prescriptions, where issued, are made solely by the treating clinician within
          their scope of practice and licensing jurisdiction. GMW does not influence, review,
          or guarantee any prescription decision. Medication-related questions should be
          directed to the prescribing clinician or your pharmacist.
        </p>

        <h2 style={s.h2}>14. Governing Law and Dispute Resolution</h2>
        <p style={s.p}>
          These Terms are governed by the laws of Kenya. Any dispute arising from these Terms
          or your use of the platform shall first be attempted to be resolved through good-faith
          negotiation. If negotiation fails within 30 days, the dispute shall be referred to
          mediation in Eldoret, Kenya. If mediation fails, the dispute shall be resolved in
          the courts of Kenya with exclusive jurisdiction in Eldoret.
        </p>

        <h2 style={s.h2}>15. Severability</h2>
        <p style={s.p}>
          If any provision of these Terms is found to be unenforceable or invalid, that
          provision shall be limited or eliminated to the minimum extent necessary so that
          the remaining provisions remain in full force and effect.
        </p>

        <h2 style={s.h2}>16. Entire Agreement</h2>
        <p style={s.p}>
          These Terms, together with the <a style={s.a} href="/privacy">Privacy Policy</a>,
          constitute the entire agreement between you and GMW regarding use of the platform
          and supersede all prior agreements or understandings.
        </p>

        <h2 style={s.h2}>17. Changes to These Terms</h2>
        <p style={s.p}>
          We may update these Terms from time to time. Material changes will be communicated
          via email or a prominent notice on the platform at least 14 days before they take
          effect. Your continued use after the effective date constitutes acceptance.
        </p>

        <h2 style={s.h2}>18. Contact Us</h2>
        <p style={s.p}>
          <strong>Global Mind Wellness Centre</strong><br />
          Eldoret, Kenya<br />
          Phone: +254 711 381 420<br />
          WhatsApp: +254 711 381 420<br />
          Email: <a style={s.a} href="mailto:care@globalmindwellness.org">care@globalmindwellness.org</a>
        </p>

        <div style={s.footer}>
          &copy; 2026 Global Mind Wellness Centre. All rights reserved.
        </div>
      </div>
    </div>
  );
}
